import { SensorData } from 'Simulations/SensorPoint';
import { FilterStage, StageParameters } from '../../Stage';
import { StageContext } from '../../Context';

export interface CloseToProjectSketchStageParameters extends StageParameters {
    minValue: number;
    maxValue: number;
    distanceToRoof: boolean;
    distanceToWall: boolean;
    distanceToEdges: boolean;
}

class CloseToProjectSketchStage extends FilterStage<CloseToProjectSketchStageParameters> {
    protected filter(sensorData: SensorData, _context: StageContext): boolean {
        const parentSensorPoint = sensorData.getSensorPoint();
        const wallDistance = parentSensorPoint.getDistanceToProjectSketchWall();
        const roofDistance = parentSensorPoint.getDistanceToProjectsketchRoof();
        const edgesDistance = parentSensorPoint.getDistanceToProjectSketchOverall();
        const { minValue, maxValue, distanceToWall, distanceToRoof, distanceToEdges } = this.getParams();

        const inRange = (distance: number) => distance >= minValue && distance <= maxValue;

        const wallOk = distanceToWall && wallDistance >= 0 && inRange(wallDistance);
        const roofOk = distanceToRoof && roofDistance >= 0 && inRange(roofDistance);

        // edges only for non‑perpendicular points
        const edgesOk =
            distanceToEdges &&
            (wallDistance < 0 || wallDistance > maxValue) &&
            (roofDistance < 0 || roofDistance > maxValue) &&
            edgesDistance >= 0 &&
            inRange(edgesDistance);

        return wallOk || roofOk || edgesOk;
    }
}

export default CloseToProjectSketchStage;
